import { LinearProgress, Typography } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { useGetCoursesQuery } from "../../api/rtk/CourseApi";
import { NewEntityId } from "../../data/constants";
import { CourseIndex } from "../../model/Course";
import { routesPaths } from "../../Routes";
import { navigateTo } from "../../utils/Navigation";
import TranslatedMessage from "../translations/TranslatedMessage";
import CourseGrid from "./CourseGrid";

const CourseList = () => {
  const { data: courses, isFetching } = useGetCoursesQuery();
  const history = useHistory();

  if (isFetching) {
    return <LinearProgress variant="query" />;
  }

  return (
    <React.Fragment>
      <Typography variant="h5">
        <TranslatedMessage id="course.list.header" />
      </Typography>
      <CourseGrid
        courses={courses ?? []}
        onRowClick={(row: CourseIndex) => navigateTo(routesPaths.course(row.id), history)}
        onAddClick={() => history.push(routesPaths.course(NewEntityId))}
      />
    </React.Fragment>
  );
};

export default CourseList;
